(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-photo-reviews"] && !Shopify.designMode) return;
  try {
    
  const reviewStar = (filled) => `
    <svg viewBox="0 0 24 24" aria-hidden="true" class="photo-reviews__star${filled ? ' is-filled' : ''}">
      <path d="M12 2.7l2.8 5.7 6.3.9-4.6 4.4 1.1 6.3-5.6-3-5.6 3 1.1-6.3-4.6-4.4 6.3-.9L12 2.7z"></path>
    </svg>`;

  const reviewStars = (rating) => Array.from({ length: 5 }, (_, index) => reviewStar(index < rating)).join('');

  const formatReviewDate = (dateValue) => {
    if (!dateValue) return '';
    const parts = dateValue.split('-');
    if (parts.length !== 3) return dateValue;
    return `${parts[2]}/${parts[1]}/${parts[0]}`;
  };

  const createReviewCard = (review) => {
    const card = document.createElement('article');
    card.className = 'photo-reviews__card';
    card.dataset.reviewCard = '';
    card.dataset.rating = String(review.rating);

    const content = document.createElement('div');
    content.className = 'photo-reviews__content';

    const nameLine = document.createElement('div');
    nameLine.className = 'photo-reviews__name-line';
    const name = document.createElement('strong');
    name.textContent = review.name || 'Anonymous';
    nameLine.append(name);

    if (review.verified) {
      const verified = document.createElement('span');
      verified.className = 'photo-reviews__verified';
      verified.setAttribute('aria-label', 'Verified buyer');
      verified.innerHTML = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 1.7a8.3 8.3 0 100 16.6 8.3 8.3 0 000-16.6zm-1.2 12L5.4 10.3l1.2-1.2 2.2 2.2 4.6-4.6 1.2 1.2-5.8 5.8z"></path></svg><span>Verified</span>';
      nameLine.append(verified);
    }
    content.append(nameLine);

    if (review.date) {
      const date = document.createElement('p');
      date.className = 'photo-reviews__date';
      date.textContent = formatReviewDate(review.date);
      content.append(date);
    }

    const stars = document.createElement('div');
    stars.className = 'photo-reviews__card-stars';
    stars.setAttribute('aria-label', `${review.rating} out of 5 stars`);
    stars.innerHTML = reviewStars(review.rating);
    content.append(stars);

    if (review.title) {
      const title = document.createElement('strong');
      title.textContent = review.title;
      content.append(title);
    }

    const body = document.createElement('div');
    body.className = 'photo-reviews__text';
    body.textContent = review.body || '';
    content.append(body);
    card.append(content);
    return card;
  };

  const updateReviewSummary = (section, reviews) => {
    const count = reviews.length;
    const customCount = Number.parseInt(section.dataset.verifiedReviewCount, 10);
    const displayCount = section.dataset.reviewCountMode === 'verified_total' && Number.isFinite(customCount) && customCount >= count ? customCount : count;
    const total = reviews.reduce((sum, review) => sum + Number(review.rating || 0), 0);
    const average = count ? (total / count).toFixed(1) : '0';
    const distribution = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
    reviews.forEach((review) => { distribution[review.rating] += 1; });

    section.querySelector('[data-review-total]').textContent = displayCount;
    section.querySelector('[data-review-average]').textContent = average;
    section.querySelector('[data-review-summary]').setAttribute('aria-label', `Show rating details: ${average} out of 5 stars from ${displayCount} reviews`);
    section.querySelectorAll('[data-review-summary] .photo-reviews__star').forEach((star, index) => {
      star.classList.toggle('is-filled', index < Math.round(Number(average)));
    });

    section.querySelectorAll('[data-distribution-rating]').forEach((row) => {
      const rating = Number(row.dataset.distributionRating);
      const ratingCount = distribution[rating] || 0;
      const percent = count ? Math.round((ratingCount / count) * 100) : 0;
      row.querySelector('[data-rating-count]').textContent = ratingCount;
      row.querySelector('[data-rating-bar]').style.setProperty('--rating-width', `${percent}%`);
    });
  };

  const initializeGlobalReviews = async (section) => {
    if (section.dataset.useGlobalReviews !== 'true' || section.dataset.reviewsLoaded === 'true') return;
    section.dataset.reviewsLoaded = 'true';

    const grid = section.querySelector('[data-review-grid]');
    const loadMore = section.querySelector('[data-load-more]');
    const pageSize = Math.max(4, Number(section.dataset.reviewsPageSize) || 20);

    try {
      const response = await fetch(section.dataset.globalReviewsUrl);
      if (!response.ok) throw new Error('Reviews file could not be loaded.');
      const data = await response.json();
      const reviews = Array.isArray(data.reviews) ? data.reviews : [];
      let shown = 0;

      updateReviewSummary(section, reviews);

      const renderNext = () => {
        reviews.slice(shown, shown + pageSize).forEach((review) => {
          const card = createReviewCard(review);
          if (section.dataset.showReviewDates !== 'true') {
            const date = card.querySelector('.photo-reviews__date');
            if (date) date.remove();
          }
          grid.append(card);
        });
        shown = Math.min(shown + pageSize, reviews.length);
        loadMore.hidden = shown >= reviews.length;
      };

      loadMore.addEventListener('click', renderNext);
      renderNext();
    } catch (error) {
      grid.innerHTML = '<p class="photo-reviews__empty">Reviews could not be loaded. Check that global-reviews.json is uploaded in Theme assets.</p>';
      loadMore.hidden = true;
    }
  };

  const initializeReviewSections = (root = document) => {
    root.querySelectorAll('.photo-reviews').forEach(initializeGlobalReviews);
  };

  initializeReviewSections();
  document.addEventListener('shopify:section:load', (event) => initializeReviewSections(event.target));

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-review-filter]');
    if (button) {
      const section = button.closest('.photo-reviews');
      const selectedRating = button.dataset.reviewFilter;

      section.querySelectorAll('[data-review-card]').forEach((card) => {
        card.hidden = selectedRating !== 'all' && card.dataset.rating !== selectedRating;
      });

      const details = button.closest('details');
      if (details) details.open = false;
    }

    document.querySelectorAll('[data-rating-details][open]').forEach((details) => {
      if (!details.contains(event.target)) details.open = false;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
